import React from 'react';

import { Container } from './styles';

const ModalTitle: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ModalTitle;
